/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 836:
/***/ (function() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Whisperer = function () {
  function Whisperer(input) {
    _classCallCheck(this, Whisperer);
    this.input = input;
    this.sentences = this._getSentences();
    this.currentIndex = 0;
    this.isTyping = false;
    this.isPaused = false;
    this.typingSpeed = 100;
    this.deletingSpeed = 50;
    this.pauseAfterTyping = 2000;
    this.pauseAfterDeleting = 500;
    if (this.sentences.length > 0) {
      this._init();
    }
  }
  return _createClass(Whisperer, [{
    key: "_getSentences",
    value: function _getSentences() {
      var sentencesAttr = this.input.getAttribute('data-whisperer-sentences');
      if (!sentencesAttr) return [];
      return sentencesAttr.split(',').map(function (s) {
        return s.trim();
      }).filter(function (s) {
        return s.length > 0;
      });
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this = this;
      if (this.input.value) return;
      this.input.addEventListener('focus', function () {
        _this.stop();
        _this.input.placeholder = _this.input.getAttribute('placeholder') || '';
      });
      this.input.addEventListener('blur', function () {
        if (!_this.input.value) {
          setTimeout(function () {
            if (!_this.input.value) {
              _this.start();
            }
          }, 500);
        }
      });
      this.start();
    }
  }, {
    key: "start",
    value: function start() {
      if (this.isTyping) return;
      this.isTyping = true;
      this.isPaused = false;
      this._type();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isTyping = false;
      this.isPaused = true;
      this.input.placeholder = '';
    }
  }, {
    key: "_type",
    value: function () {
      var _type2 = _asyncToGenerator(_regenerator().m(function _callee() {
        var sentence, currentText, i;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!this.isTyping || this.isPaused)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              sentence = this.sentences[this.currentIndex];
              currentText = '';
              i = 0;
            case 2:
              if (!(i <= sentence.length)) {
                _context.n = 5;
                break;
              }
              if (!(!this.isTyping || this.isPaused)) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              currentText = sentence.substring(0, i);
              this.input.placeholder = currentText;
              _context.n = 4;
              return this._wait(this.typingSpeed);
            case 4:
              i++;
              _context.n = 2;
              break;
            case 5:
              _context.n = 6;
              return this._wait(this.pauseAfterTyping);
            case 6:
              _context.n = 7;
              return this._delete(sentence);
            case 7:
              this.currentIndex = (this.currentIndex + 1) % this.sentences.length;
              _context.n = 8;
              return this._wait(this.pauseAfterDeleting);
            case 8:
              if (this.isTyping && !this.isPaused) {
                this._type();
              }
            case 9:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function _type() {
        return _type2.apply(this, arguments);
      }
      return _type;
    }()
  }, {
    key: "_delete",
    value: function () {
      var _delete2 = _asyncToGenerator(_regenerator().m(function _callee2(sentence) {
        var i, currentText;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!this.isTyping || this.isPaused)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              i = sentence.length;
            case 2:
              if (!(i >= 0)) {
                _context2.n = 5;
                break;
              }
              if (!(!this.isTyping || this.isPaused)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              currentText = sentence.substring(0, i);
              this.input.placeholder = currentText;
              _context2.n = 4;
              return this._wait(this.deletingSpeed);
            case 4:
              i--;
              _context2.n = 2;
              break;
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function _delete(_x) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
  }, {
    key: "_wait",
    value: function _wait(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    }
  }]);
}();
document.addEventListener('DOMContentLoaded', function () {
  var inputs = document.querySelectorAll('[data-whisperer-sentences]');
  inputs.forEach(function (input) {
    if (!input._whisperer) {
      input._whisperer = new Whisperer(input);
    }
  });
});
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    var inputs = document.querySelectorAll('[data-whisperer-sentences]');
    inputs.forEach(function (input) {
      if (!input._whisperer) {
        input._whisperer = new Whisperer(input);
      }
    });
  });
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _partials_whisperer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(836);
/* harmony import */ var _partials_whisperer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_partials_whisperer__WEBPACK_IMPORTED_MODULE_0__);



}();
/******/ })()
;